import miniStory1 from '@/shared/assets/stories/mini_story_1.png';
import first_story_1 from '@/shared/assets/stories/1_story_1.png';
import first_story_2 from '@/shared/assets/stories/1_story_2.png';
import first_story_3 from '@/shared/assets/stories/1_story_3.png';
import miniStory2 from '@/shared/assets/stories/mini_story_2.png';
import miniStory3 from '@/shared/assets/stories/mini_story_3.png';
import miniStory4 from '@/shared/assets/stories/mini_story_4.png';
import third_story_1 from '@/shared/assets/stories/3_story_1.png';
import third_story_2 from '@/shared/assets/stories/3_story_2.png';
import third_story_3 from '@/shared/assets/stories/3_story_3.png';
import third_story_4 from '@/shared/assets/stories/3_story_4.png';
import fourth_story_1 from '@/shared/assets/stories/4_story_1.png';
import fourth_story_2 from '@/shared/assets/stories/4_story_2.png';
import fourth_story_3 from '@/shared/assets/stories/4_story_3.png';
import fourth_story_4 from '@/shared/assets/stories/4_story_4.png';
import second_story_1 from '@/shared/assets/stories/2_story_1.png';
import second_story_2 from '@/shared/assets/stories/2_story_2.png';
import second_story_3 from '@/shared/assets/stories/2_story_3.png';
import { MiniStory, Story } from './types';
import cls from '../ui/StoriesModal.module.scss';

const INCLUDED_STORIES_1: Story[] = [
    { id: 0, title: 'Как распределяются вложенные в\u00A0стратегию средства?', backgroundImage: first_story_1 },
    {
        id: 1,
        title: '99,15%',
        description: 'Идёт на покупку облигаций и/или инструментов денежного рынка.',
        backgroundImage: first_story_2,
    },
    {
        id: 2,
        title: '0,85%',
        description: (
            <span>
                Распределяется на&nbsp;страхование и&nbsp;компенсацию
                <br className={cls.mobileBr} /> услуг Страховой
                <br className={cls.mobileBr} /> компании.
            </span>
        ),
        backgroundImage: first_story_3,
    },
];

const INCLUDED_STORIES_2: Story[] = [
    { id: 0, title: 'Из чего складывается доходность стратегии?', backgroundImage: second_story_1 },
    {
        id: 1,
        title: 'Инвестируя в\u00A0«Квадратные метры»',
        description: 'Вы получаете доход, привязанный к росту цен на недвижимость в\u00A0Москве.',
        backgroundImage: second_story_2,
    },
    {
        id: 2,
        title: 'Через два года',
        description: 'Вы гарантированно получаете купонный доход от 0,01% до 5% от вложенной суммы.',
        backgroundImage: second_story_3,
    },
];

const INCLUDED_STORIES_3: Story[] = [
    { id: 0, title: 'Как можно использовать стратегию?', backgroundImage: third_story_1 },
    {
        id: 1,
        title: 'Стратегия «Квадратные метры»',
        description: 'представляет собой низкорисковый и\u00A0высокодоходный инвестиционный инструмент.',
        backgroundImage: third_story_2,
    },
    {
        id: 2,
        title: 'Сценарий 1',
        description:
            'Через два года вывести\u00A0часть или все средства с доходом до\u00A05% годовых и\u00A0использовать их по своему усмотрению — например, на покупку недвижимости или ипотечный взнос.',
        backgroundImage: third_story_3,
    },
    {
        id: 3,
        title: 'Сценарий 2',
        description: 'Продолжить инвестирование в\u00A0стратегию и\u00A0увеличивать капитал.',
        backgroundImage: third_story_4,
    },
];

const INCLUDED_STORIES_4: Story[] = [
    { id: 0, title: 'Как изменения на рынке повлияют на\u00A0мой портфель?', backgroundImage: fourth_story_1 },
    {
        id: 1,
        title: 'С ростом цен растёт и\u00A0стоимость портфеля',
        description: (
            <span>
                а при падении рынка
                <br />– остается на макс. достигнутом уровне.
            </span>
        ),
        backgroundImage: fourth_story_2,
    },
    {
        id: 2,
        title: 'Если ситуация на рынке стабильна',
        description:
            'Стоимость портфеля не\u00A0меняется, но через 2\u00A0года клиент гарантированно получает купонный доход от 0,01 до 5% годовых.',
        backgroundImage: fourth_story_3,
    },
    {
        id: 3,
        title: 'Следите',
        description: 'за ценой м² в Москве на сайте ДОМ.РФ, а\u00A0за\u00A0портфелем — в\u00A0личном кабинете.',
        backgroundImage: fourth_story_4,
    },
];

export const STORIES: MiniStory[] = [
    {
        id: 0,
        title: 'Как распределяются вложенные в\u00A0стратегию средства?',
        image: miniStory1,
        includedStories: INCLUDED_STORIES_1,
        alignment: 'end',
    },
    {
        id: 1,
        title: (
            <span>
                Из чего
                <br />
                складывается
                <br />
                доходность
                <br />
                стратегии?
            </span>
        ),
        image: miniStory2,
        includedStories: INCLUDED_STORIES_2,
    },
    {
        id: 2,
        title: (
            <span>
                Как можно
                <br />
                использовать
                <br />
                стратегию?
            </span>
        ),
        image: miniStory3,
        includedStories: INCLUDED_STORIES_3,
    },
    {
        id: 3,
        title: (
            <span>
                Как изменения
                <br />
                на рынке
                <br />
                повлияют
                <br />
                на мой
                <br />
                портфель?
            </span>
        ),
        image: miniStory4,
        includedStories: INCLUDED_STORIES_4,
    },
];

export const STORIES_MAP = new Map<number, Story[]>();

STORIES.forEach((story) => {
    STORIES_MAP.set(story.id, story.includedStories);
});
